/**
 * When an agent answers a comment, and when it stays quiet (RFC 0324 3g).
 *
 * Every comment still reaches the agent. This one sentence, said wherever a
 * comment wakes it, is how it learns which ones want an answer. Silence is
 * not an absence: passing is recorded, and the thread shows "read".
 */
export const COMMENT_ANSWER_RULE =
  'Answer a question, a request, or anything addressed to you. A note meant ' +
  'for someone else, an FYI or a thanks needs no answer: call pass with the ' +
  "comment's id as commentId and write nothing, and the thread shows you read it."
